import common from "./common";
import navigation from "./navigation";
import auth from "./auth";
import dashboard from "./dashboard";
import routineTasks from "./routineTasks";
import oneTimeTasks from "./oneTimeTasks";
import manageRoutineTasks from "./manageRoutineTasks";
import reportedTasks from "./reportedTasks";
import charts from "./charts";
import users from "./users";
import projects from "./projects";
import components from "./components";
import validation from "./validation";
import profile from "./profile";
import landing from "./landing";

export default {
  common,
  navigation,
  auth,
  dashboard,
  routineTasks,
  oneTimeTasks,
  manageRoutineTasks,
  reportedTasks,
  charts,
  users,
  projects,
  components,
  validation,
  profile,
  landing,
};
